import {
  Select,
  FormLabel,
  FormControl,
  InputGroup,
  Text,
} from '@chakra-ui/react';

const FormikSelect = ({
  formik,
  label,
  name="",
  placeholder,
  labelColor,
  labelSize,
  icon,
  inputStyle,
  style,
  children
}) => {
  return (
    <FormControl style={style}>
      <FormLabel
        color={labelColor ? labelColor : "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize ? labelSize : 12}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <Select
          name={name}
          value={formik && formik?.values[name]}
          onChange={formik && formik?.handleChange}
          placeholder={placeholder}
          icon={icon}
          style={inputStyle}
          height={"48px"}
          bg={"transparent"}
          fontFamily={"PlusJakartaSansRegular"}
          borderRadius={"4px"}
          fontSize={"12px"}
          color={"#000000"}
          _placeholder={{ color: "#898989" }}
        >
          {children}
        </Select>
      </InputGroup>
      {formik && formik?.touched[name] && formik?.errors[name] ? (
        <Text color="#800" fontSize="10px">
          {formik?.errors[name]}
        </Text>
      ) : null}
    </FormControl>
  );
}

export default FormikSelect